import SyTextEditor from './sy-text-editor';

export default SyTextEditor;